// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as AccountSettingsComponent} from './AccountSettings.svg';

import Icon, { TIconProps } from '../Icon';

export const IconAccountSettings = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <AccountSettingsComponent/>
  </Icon>
));
